import React from "react";
import BarChartComponent from "./BarChartComponent";

interface DoubleStackedBarChartParams {
  data: {
    yBottom: Array<number>;
    yTop: Array<number>;
    x: Array<number | string>;
  };
  legend: {
    yBottom: string;
    yTop: string;
  };
  dataLabelFormatter?(label: string): void;
}

const DoubleStackedBarChart: React.FC<DoubleStackedBarChartParams> = ({
  data = {
    yBottom: [],
    yTop: [],
    x: [],
  },
  legend = {
    yBottom: "",
    yTop: "",
  },
  dataLabelFormatter = (label: string) => {},
}) => {
  const options = {
    responsive: true,
    interaction: {
      intersect: false,
      mode: "index",
    },
    plugins: {
      datalabels: {
        align: "top",
        anchor: "end",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: function (value: string, context: string) {
          return dataLabelFormatter(value);
        },
      },
      legend: {
        display: true,
        align: "end",
        position: "top",
      },
      tooltip: {
        yAlign: "top",
        callbacks: {
          label: (y: any) => `${y.dataset.label}: ` + dataLabelFormatter(y.raw),
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { display: false },
        border: { display: false },
      },
      y: {
        stacked: true,
        grid: { display: false },
        border: { display: false },
      },
    },
  };

  const chartData = {
    labels: data.x,
    datasets: [
      {
        label: legend.yBottom,
        data: data.yBottom,
        backgroundColor: "#0047BA",
        datalabels: {
          display: false,
        },
      },
      {
        label: legend.yTop,
        data: data.yTop,
        backgroundColor: "#F5E100",
        datalabels: {
          color: "#2a2a2a",
          formatter: function (value: string, context: any) {
            const dataIndex = context.dataIndex;
            const datasetIndex = context.datasetIndex;
            const datasets = context.chart.$datalabels._datasets;
            const othersValues: Array<number> = [];

            datasets.map((dt: Array<any>, index: number) => {
              if (index == datasetIndex) return;
              const lineValue =
                dt[index]["$context"]["dataset"]["data"][dataIndex];
              othersValues.push(lineValue);
            });

            const sumOtherValues = othersValues.reduce(
              (acc: number, item: number) => {
                return acc + item;
              },
              0
            );

            const sum = sumOtherValues + value;

            const finalString = dataLabelFormatter(sum);
            return finalString;
          },
        },
      },
    ],
  };

  return <BarChartComponent height="100%" data={chartData} options={options} />;
};

export default DoubleStackedBarChart;
